import { useAppDispatch } from '../../../../App/redux/store';
import { modalsActions } from '../../../modals/modalsSlice';
import MyFolderFormComponent from '../folderForm/FolderFormComponent';
import './folderEditModal.scss';

function FolderEditModal() {
  const dispatch = useAppDispatch();

  const handleCancel = () => dispatch(modalsActions.updateFolder(null));

  return (
    <div className="edit-folders">
      <div className="edit-folders-modal">
        <h3 className="edit-folders-title">Modifier le dossier</h3>
        <MyFolderFormComponent handleCancel={handleCancel} isModal={true} />
      </div>
    </div>
  );
}

export default FolderEditModal;
